<template>
  <!-- <applyexpert> </applyexpert> -->
  <div v-if="!selectedItem" class="search-bar">

    <el-row :gutter="10" class="custom-row">
      <el-col :span="8">
        <el-select v-model="selectedLetter" placeholder="姓氏首字母">
          <el-option v-for="(letter, index) in letters" :key="index" :label="letter" :value="letter">
          </el-option>
        </el-select>
      </el-col>

      <el-col :span="8">
        <el-select v-model="selectedLabel" placeholder="标签">
          <el-option v-for="(category, index) in categories" :key="index" :label="category" :value="category">
          </el-option>
        </el-select>
      </el-col>

      
      <el-col :span="4">
        <el-button type="primary" @click="resetItems" class="reset-button-container">重置</el-button>
      </el-col>

      <el-col :span="4">
        <el-button type="primary" @click="filterItems">检索</el-button>
      </el-col>






    </el-row>
  </div>

  <div>
    <div v-if="!selectedItem">
      <el-row :gutter="20">
        <el-col :span="8" v-for="item in filteredItems" :key="item.id">
          <el-card class="hover-card">
            <div class="card-body">
              <img :src="item.profileImage" alt="头像" class="avatar-image" />
              <div class="card-content">
                <p class="name">{{ item.name }}</p>
                <p class="info"><strong>地址：</strong>{{ item.location }}</p>
                <p class="info"><strong>电话：</strong>{{ item.phoneNumber }}</p>
                <p class="info"><strong>邮箱：</strong>{{ item.email }}</p>
              </div>
            </div>
            <div class="card-footer">
              <el-button type="primary" class="detail-button" @click="showDetail(item)">详情 -></el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-pagination background layout="sizes, prev, pager, next, jumper, ->, total" :page-size="pageParam.pageSize"
        :current-page="pageParam.pageNum" :page-sizes="pageSizes" :total="total" :hide-on-single-page="true"
        @current-change="handleCurrentChange" @size-change="handleSizeChange">
      </el-pagination>
    </div>

    <div v-else>
      <el-card>
        <el-form :model="selectedItem" label-width="200px" class="form-container">
          <!-- First row -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="姓名">
                <el-input v-model="selectedItem.name" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮箱">
                <el-input v-model="selectedItem.email" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电话">
                <el-input v-model="selectedItem.phoneNumber" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地点">
                <el-input v-model="selectedItem.location" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- Second row -->
          <el-col :span="12">
            <el-form-item label="年限">
              <el-input v-model="selectedItem.yearsOfExperience" disabled></el-input>
            </el-form-item>
          </el-col>

          <!-- Other fields -->
          <el-form-item label="简介" class="full-width">
            <el-input type="textarea" v-model="selectedItem.biography" disabled></el-input>
          </el-form-item>
          <el-form-item label="专长" class="full-width">
            <el-input v-model="selectedItem.specialization" disabled></el-input>
          </el-form-item>
          <el-form-item label="资格" class="full-width">
            <el-input type="textarea" v-model="selectedItem.qualifications" disabled></el-input>
          </el-form-item>
          <el-form-item label="活跃">
            <el-switch v-model="selectedItem.active" :active-value="1" :inactive-value="0" disabled></el-switch>
          </el-form-item>
          <el-form-item label="评分">
            <el-rate v-model="selectedItem.rating" disabled></el-rate>
          </el-form-item>

          <!-- Back button -->
          <el-form-item class="button-container">
            <el-button type="primary" @click="backToList">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { baseUrl_New } from '../../axios/urlconfig';
import { getRequest, postRequest } from '../../axios/axios';
// import pinyin from 'pinyin'; // 导入pinyin库

import applyexpert from '@/home/expert/applyexpert';

export default {
  data() {
    return {
      components: {
        applyexpert,
      },
      selectedLetter: '',
      selectedLabel: '',
      letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      categories: [],
      items: [],
      filteredItems: [],
      selectedItem: null,
      pageParam: {
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      pageSizes: [15, 30]
    };
  },
  created() {
    this.getAllList();
    this.getExpertLabel();
  },
  methods: {
    resetItems() {
      this.selectedLabel = '';
      this.selectedLetter = '';
      this.pageParam.pageNum = 1; // 重置页码
      this.getAllList();
    },

    getExpertLabel() {
      getRequest(baseUrl_New + "/expert/label").then(res => {
        this.categories = res.data.data;
      });
    },
    async getAllList() {
      try {
        const response = await postRequest(baseUrl_New + '/expert/all'
          , {
            selectedLetter: this.selectedLetter,
            selectedLabel: this.selectedLabel,
            pageNum: this.pageParam.pageNum,
            pageSize: this.pageParam.pageSize
          });
        const resultMap = response.data.data;
        this.items = resultMap.list; // 根据返回的数据结构进行调整
        this.filteredItems = this.items; // 初始化时显示所有用户
        this.total = resultMap.total; // 根据返回的数据结构进行调整
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
    handleCurrentChange(pageNum) {
      this.pageParam.pageNum = pageNum;
      this.getAllList();
    },
    handleSizeChange(pageSize) {
      this.pageParam.pageSize = pageSize;
      this.pageParam.pageNum = 1;
      this.getAllList();
    },
    filterItems() {
      this.pageParam.pageNum = 1; // 重置页码
      this.getAllList();
    },
    showDetail(item) {
      this.selectedItem = { ...item, active: Number(item.active) };
    },
    backToList() {
      this.selectedItem = null;
    }
  }
};
</script>



<style scoped>
.card-body {
  display: flex;
  flex-direction: row;
}

.avatar-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  margin-right: 20px;
}

.card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.name {
  font-size: 18px;
  font-weight: bold;
  color: #673ab7;
  margin-bottom: 10px;
}

.info {
  font-size: 14px;
  color: #555;
  margin-bottom: 5px;
}

.hover-card {
  transition: box-shadow 0.3s ease, background-color 0.3s ease, background-image 0.3s ease;
  padding: 20px;
  background-color: #fff;
  position: relative;
  height: 250px;
  margin-bottom: 20px;
}

.hover-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  background: linear-gradient(to right,
      rgba(100, 149, 237, 1),
      rgba(100, 149, 237, 0.8) 20%,
      rgba(70, 130, 180, 0.6) 40%,
      rgba(65, 105, 225, 0.4) 60%,
      rgba(0, 0, 139, 0.2) 80%,
      rgba(0, 0, 255, 0.1));
  background-size: 8% 100%;
  background-repeat: no-repeat;
  background-position: left bottom;
}

.card-footer {
  margin-top: 10px;
  text-align: right;
  visibility: hidden;
}

.hover-card:hover .card-footer {
  visibility: visible;
}

.detail-button {
  display: none;
}

.hover-card:hover .detail-button {
  display: inline-block;
}

.el-button {
  background-color: #f0f0f0;
  color: #000;
  border: none;
  position: absolute;
  bottom: 15px;
  right: 15px;
  transition: background-color 0.3s, color 0.3s;
}

.el-button:hover {
  background-color: #673ab7;
  color: #fff;
}

/* 添加针对表单自适应的样式 */
.el-form {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  /* 分散对齐，使空间均匀分布 */
}

.el-form-item {
  flex: 1;
  /* 让表单项平均分配可用空间 */
  min-width: 300px;
  /* 设置最小宽度以避免极端情况下宽度过小 */
  margin-bottom: 10px;
  /* 控制表单项间的间距 */
}

/* 对于特定需要全宽度展示的表单项（如简介），可以单独设置 */
.full-width {
  flex: 0 0 100%;
  max-width: 100%;
  margin-bottom: 20px;
  /* 可以适当增加底部间距 */
}

.form-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
}


.custom-row {
  margin-bottom: 10px;
  /* 增加整体的垂直间距 */
}


.reset-button-container {
  position: relative;
  left: 200px; /* 根据需要调整偏移量 */
  bottom: 5px;
}
.custom-col {
  margin-bottom: 10px;
  /* 增加每个列的垂直间距 */
}

.search-bar .el-col:not(:last-child) {
  margin-bottom: 10px;
  /* 每个列的底部间距 */
}
</style>